module.exports = __webpack_public_path__ + "img/01-6.9afd32d7.png";